export const assetUrl = (source: string) => {
  const cdnUrl =
    process.env.NEXT_PUBLIC_CDN_HOST_URL || "/cdn"
  return cdnUrl + source
}

export const HEADER_WEB_VERSION = 4
